import ApiClient from "@common/api/ApiClient";

class GuardianClient extends ApiClient {
  constructor() {
    super("");
    this.setApiUrlKey("comp_api_url");
  }

  request = async (endpoint, method, data = {}, options = {}) => {
    const url = `${sessionStorage.getItem(this.apiUrlKey)}/${endpoint}`;
    return await this.axios.request({
      url,
      method,
      data,
      ...options,
    });
  };

  getCustomerInteractionConfig = async () => {
    return await this.get("CustomerInteractionConfiguration/Read");
  };

  getCustomerInteractionConfigForUpdate = async () => {
    return await this.get("CustomerInteractionConfiguration/Update");
  };

  updateCustomerInteractionConfig = async (payload) => {
    return await this.post("CustomerInteractionConfiguration/Update", payload);
  };
}

const client = new GuardianClient();

export default client;
